<template>
    <div class="menus-content">
        <el-tabs v-model="tableActive" type="border-card" @tab-click="tabClick">
            <el-tab-pane name="tb">
                <span slot="label">
                    <img class="menu-type-img" :src="require('@/index/assets/shop_img/淘宝.png')" alt="alt" />
                    <span>淘宝</span>
                </span>
                <div>
                    <menus-taobao />
                </div>
            </el-tab-pane>
            <template v-if="showDyTab">
            <el-tab-pane name="dy">
                <span slot="label">
                    <img class="menu-type-img" :src="require('@/index/assets/shop_img/抖音.png')" alt="alt" />
                    <span>抖音</span>
                </span>
                <div>
                    <menus-dy />
                </div>
            </el-tab-pane>
            </template>
            <el-tab-pane name="pdd">
                <span slot="label">
                    <img class="menu-type-img" :src="require('@/index/assets/shop_img/拼多多.png')" alt="alt" />
                    <span>拼多多</span>
                </span>
                <div>
                    <menus-pdd />
                </div>
            </el-tab-pane>
            <el-tab-pane name="1688">
                <span slot="label">
                    <img class="menu-type-img" :src="require('@/index/assets/shop_img/1688.png')" alt="alt" />
                    <span>1688</span>
                </span>
                <div>
                    <menus-albb />
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import MenusTaobao from "./MenusTaobao"
import MenusDy from "../../first_flow_dy/_components/MenusDy"
import MenusPdd from "../../first_flow_pdd/_components/MenusPdd"
import MenusAlbb from "../../first_flow_albb/_components/MenusAlbb"

export default {
    name: 'Menus',
    components: {
        MenusTaobao,
        MenusDy,
        MenusPdd,
        MenusAlbb,
    },
    data() {
        return {
            tableActive: "",
            showDyTab: false,
        }
    },
    created() {
        // first-flow-dy/first-flow
        if (this.$route.path.includes("first-flow-dy") || this.$route.path.includes("dy-first-page")) {
            // 路由里面带抖音, 则 tab 切换到抖音
            this.tableActive = "dy";
            this.showDyTab = true;
        } else if (this.$route.path.includes("first-flow-pdd")) {
            // 路由里面带拼多多, 则 tab 切换到拼多多
            this.tableActive = "pdd";
        } else if (this.$route.path.includes("first-flow-albb")) {
            this.tableActive = "1688";
        } else {
            // 其它所有路由的 tab 切换到淘宝
            this.tableActive = "tb";
        }
    },
    methods: {
        tabClick(tab) {
            if (tab.name === "dy" && !this.$route.path.includes("first-flow-dy")) {
                // 抖音
                this.$router.push({
                    path: "/first-flow-dy/first-flow"
                })
            } else if (tab.name === "pdd" && !this.$route.path.includes("first-flow-pdd")) {
                // 拼多多
                this.$router.push({
                    path: "/first-flow-pdd/said-ok"
                })
            } else if (tab.name === "tb") {
                // 淘宝
                this.$router.push({
                    path: "/head_screen/recommend"
                })
            } else if (tab.name === "1688") {
                // 淘宝
                this.$router.push({
                    path: "/first-flow-albb"
                })
            }
        },
    }
}
</script>

<style scoped lang="scss">
.menus-content {
    padding-bottom: 20px;
    .menu-type-img {
        width: 30px;
        height: 30px;
        margin-right: 6px;
    }
}

</style>
